import { RoyaltyRegistryABI, RoyaltyRegistryStorageABI } from './abis';

/**
 *
 * 39797    - Energi Mainnet
 * 49797    - Energi Testnet
 * 1        - Ethereum Mainnet
 * 11155111 - Sepolia Testnet
 * 33139    - ApeChain
 * 33111    - Curtis
 * 443      - TEN Testnet
 * 143      - Monad Mainnet
 * 56       - Binance Mainnet
 * 97       - Binance Testnet
 *
 */
export default {
  49797: {
    RoyaltyRegistry: {
      address: '0xbc204646c2d40716e5586a25ca96c7f9d599bf1d',
      ABI: RoyaltyRegistryABI,
    },
    RoyaltyRegistryStorage: {
      address: '0x643746ae53578d31f6e7ecbc3464e10a63686c90',
      ABI: RoyaltyRegistryStorageABI,
    },
  },
  39797: {
    RoyaltyRegistry: {
      address: '0xb17c4e4fbf3a7e0f651eec4b77ab1c2c2d1cbca3',
      ABI: RoyaltyRegistryABI,
    },
    RoyaltyRegistryStorage: {
      address: '0xffe2e29a70a7f1f1a019be3b5404e3195426ad43',
      ABI: RoyaltyRegistryStorageABI,
    },
  },
  11155111: {
    RoyaltyRegistry: {
      address: '0x133440ee738FdbbD4A1D26328853eE446bDbb699',
      ABI: RoyaltyRegistryABI,
    },
    RoyaltyRegistryStorage: {
      address: '0x33f2FA9fa795a7572E9204FB87a8066d48d8eB4e',
      ABI: RoyaltyRegistryStorageABI,
    },
  },
  1: {
    RoyaltyRegistry: {
      address: '0x1f6eedf2c7e83869257a2c0d22c900f5577d7e03',
      ABI: RoyaltyRegistryABI,
    },
    RoyaltyRegistryStorage: {
      address: '0xa8c3e7acc4e5f799f414acd8d015822547a0cea9',
      ABI: RoyaltyRegistryStorageABI,
    },
  },
  33139: {
    RoyaltyRegistry: {
      address: '0xa46c1a4f05609c36f0389d6fc2ceb2e5ae86b487',
      ABI: RoyaltyRegistryABI,
    },
    RoyaltyRegistryStorage: {
      address: '0x4e992e34df70a3a903408da308bdc1349277b6cd',
      ABI: RoyaltyRegistryStorageABI,
    },
  },
  33111: {
    RoyaltyRegistry: {
      address: '0x1f6eedf2c7e83869257a2c0d22c900f5577d7e03',
      ABI: RoyaltyRegistryABI,
    },
    RoyaltyRegistryStorage: {
      address: '0xa8c3e7acc4e5f799f414acd8d015822547a0cea9',
      ABI: RoyaltyRegistryStorageABI,
    },
  },
  42161: {
    RoyaltyRegistry: {
      address: '0xb6C7263db9713E9b3bf8196729d1b855d989cfff', // TODO: Replace with Arbitrum mainnet address
      ABI: RoyaltyRegistryABI,
    },
    RoyaltyRegistryStorage: {
      address: '0xf7f85c2B835A1F1cFb0777506d47738f661562ff', // TODO: Replace with Arbitrum mainnet address
      ABI: RoyaltyRegistryStorageABI,
    },
  },
  421614: {
    RoyaltyRegistry: {
      address: '0x[TBD]', // TODO: Replace with Arbitrum Sepolia testnet address
      ABI: RoyaltyRegistryABI,
    },
    RoyaltyRegistryStorage: {
      address: '0x[TBD]', // TODO: Replace with Arbitrum Sepolia testnet address
      ABI: RoyaltyRegistryStorageABI,
    },
  },
  80094: {
    RoyaltyRegistry: {
      address: '0xc857610831aeb89c9087e5745b77da9160c3eb68',
      ABI: RoyaltyRegistryABI,
    },
    RoyaltyRegistryStorage: {
      address: '0xd0e09207b1fab3ac21ef640e9b27cb6b7912d495',
      ABI: RoyaltyRegistryStorageABI,
    },
  },
  80069: {
    RoyaltyRegistry: {
      address: '0x8eba3dd6e2728e4c858a336307c7ca1cea0575df',
      ABI: RoyaltyRegistryABI,
    },
    RoyaltyRegistryStorage: {
      address: '0xe27ba414175a518bfe3975d805adcbb11f1ceed7',
      ABI: RoyaltyRegistryStorageABI,
    },
  },
  8453: {
    RoyaltyRegistry: {
      address: '0x0D09CDb5901467FA531Aa7b1D8AC331Ab9f1F70B',
      ABI: RoyaltyRegistryABI,
    },
    RoyaltyRegistryStorage: {
      address: '0xc60E2F1D43e1D6183E5ce8FE9b575D9009AcC4cF',
      ABI: RoyaltyRegistryStorageABI,
    },
  },
  84532: {
    RoyaltyRegistry: {
      address: '0x1d08dc86f6f05898ff5f6bb24dcecd2bb48716df',
      ABI: RoyaltyRegistryABI,
    },
    RoyaltyRegistryStorage: {
      address: '0x611e58ffdbf75dda5569908b638fa2603653e862',
      ABI: RoyaltyRegistryStorageABI,
    },
  },
  1868: {
    RoyaltyRegistry: {
      address: '0xa46c1a4f05609c36f0389d6fc2ceb2e5ae86b487',
      ABI: RoyaltyRegistryABI,
    },
    RoyaltyRegistryStorage: {
      address: '0x4e992e34df70a3a903408da308bdc1349277b6cd',
      ABI: RoyaltyRegistryStorageABI,
    },
  },
  1946: {
    RoyaltyRegistry: {
      address: '0x6647a0906dbd029dd1d119de28eb8f64542979e0',
      ABI: RoyaltyRegistryABI,
    },
    RoyaltyRegistryStorage: {
      address: '0x699137bf89e9b4af7ecb503aeac8f7e41536657a',
      ABI: RoyaltyRegistryStorageABI,
    },
  },
  2741: {
    RoyaltyRegistry: {
      address: '0xb68bfe4f58495ee745d63d40a116a3f8eb31daf4',
      ABI: RoyaltyRegistryABI,
    },
    RoyaltyRegistryStorage: {
      address: '0x8a6e83cc60fb010895f801fa99f90ca043fbc730',
      ABI: RoyaltyRegistryStorageABI,
    },
  },
  11124: {
    RoyaltyRegistry: {
      address: '0xd33b3101ff1fb351cb9ee3f6aa0c38f01a77adb3',
      ABI: RoyaltyRegistryABI,
    },
    RoyaltyRegistryStorage: {
      address: '0x5b7eda82845af3dc365fcbb137d110dd2373c253',
      ABI: RoyaltyRegistryStorageABI,
    },
  },
  109: {
    RoyaltyRegistry: {
      address: '0x0000000000000000000000000000000000000000', // TODO: Replace with Shibarium mainnet address
      ABI: RoyaltyRegistryABI,
    },
    RoyaltyRegistryStorage: {
      address: '0x0000000000000000000000000000000000000000', // TODO: Replace with Shibarium mainnet address
      ABI: RoyaltyRegistryStorageABI,
    },
  },
  157: {
    RoyaltyRegistry: {
      address: '0xA510C80f3839a292b5C5723837392Edea06E1', // Puppynet testnet RoyaltyRegistryProxy
      ABI: RoyaltyRegistryABI,
    },
    RoyaltyRegistryStorage: {
      address: '0x4f7F958291c2A84Cc81Fa67c84536Aeeb3ABaBD', // Puppynet testnet RoyaltyRegistryStorage
      ABI: RoyaltyRegistryStorageABI,
    },
  },
  443: {
    RoyaltyRegistry: {
      address: '0x0bede69e7d06df0caba5852c456dbb425842e377', // TEN Testnet
      ABI: RoyaltyRegistryABI,
    },
    RoyaltyRegistryStorage: {
      address: '0xbb3286dd47afb134e1b07cfa1d0a8322f7ce2455', // TEN Testnet
      ABI: RoyaltyRegistryStorageABI,
    },
  },
  143: {
    RoyaltyRegistry: {
      address: '0x0bede69e7D06Df0caba5852C456dBB425842e377', // Monad Mainnet
      ABI: RoyaltyRegistryABI,
    },
    RoyaltyRegistryStorage: {
      address: '0xbB3286dd47aFB134E1B07CFa1D0A8322F7Ce2455', // Monad Mainnet
      ABI: RoyaltyRegistryStorageABI,
    },
  },
  // TODO: Add TEN mainnet contract addresses when available
  // [MAINNET_CHAIN_ID]: {
  //   RoyaltyRegistry: {
  //     address: 'TODO: Replace with TEN mainnet address',
  //     ABI: RoyaltyRegistryABI,
  //   },
  //   RoyaltyRegistryStorage: {
  //     address: 'TODO: Replace with TEN mainnet address',
  //     ABI: RoyaltyRegistryStorageABI,
  //   },
  // },
  // TODO: Add Monad mainnet contract addresses when available
  // [MAINNET_CHAIN_ID]: {
  //   RoyaltyRegistry: {
  //     address: 'TODO: Replace with Monad mainnet address',
  //     ABI: RoyaltyRegistryABI,
  //   },
  //   RoyaltyRegistryStorage: {
  //     address: 'TODO: Replace with Monad mainnet address',
  //     ABI: RoyaltyRegistryStorageABI,
  //   },
  // },
  56: {
    RoyaltyRegistry: {
      address: '0xb6c7263db9713e9b3bf8196729d1b855d989cfff',
      ABI: RoyaltyRegistryABI,
    },
    RoyaltyRegistryStorage: {
      address: '0xf7f85c2b835a1f1cfb0777506d47738f661562ff',
      ABI: RoyaltyRegistryStorageABI,
    },
  },
  97: {
    RoyaltyRegistry: {
      address: '0xb6c7263db9713e9b3bf8196729d1b855d989cfff',
      ABI: RoyaltyRegistryABI,
    },
    RoyaltyRegistryStorage: {
      address: '0xf7f85c2b835a1f1cfb0777506d47738f661562ff',
      ABI: RoyaltyRegistryStorageABI,
    },
  },
};
